import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  currentPage: 1,
  search: ''
};

const keepSearchProductInCatalogSlice = createSlice({
  name: 'keepSearchProductInCatalog',
  initialState,
  reducers: {
    updateSearch(
      _,
      action: PayloadAction<{
        currentPage: number;
        search: string;
      }>
    ) {
      return action.payload;
    }
  }
});

const { actions, reducer } = keepSearchProductInCatalogSlice;
export const { updateSearch } = actions;
export default reducer;
